// extracted by mini-css-extract-plugin
export default {"add":"AddCard_add__4mNJY","add__icon":"AddCard_add__icon__LNLzf","add__box":"AddCard_add__box__4jA13","add__text":"AddCard_add__text__1QnrY"};